module.exports = "https://static.energy5.com/_next/static/images/glance-5-582a5ec74c9496d8f6be08e4cc1c78cf.png";